  <div class="post-association-modal custom-theme-modal modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content modal-scrollable-content">
      <div class="modal-header d-block py-3 border-bottom">
        <div class="row">
          <div class="col-6 pr-0 d-flex align-items-center">
            <h6 class="heading-4">
              <span class="cursor-pointer" (click)="nextPostScreen.emit(2)">
                <img class="pb-1" src="assets/themes/icons/grey-arrow.svg" alt="back">
              </span>
              <span class="color-grey-700">
              {{mls.languageText.create_posting.key1}}
              <span *ngIf="mls?.is_lskey_display==1">(create_posting.key1)</span></span>
            </h6>
          </div>
          <div class="col-6 text-right">
            <button [disabled]="showColor==false"
              [ngClass]=" showColor ? 'filled' : 'filled-disabled'" (click)="fileUploadingProcess()" type="button"
              class="btn-design medium w-25 position-relative">
              {{mls.languageText.create_post_association.key2}}
              <span *ngIf="mls?.is_lskey_display==1">(create_post_association.key2)</span>
            </button>
          </div>
        </div>
        <label *ngIf="err_msg!=''">
          <span class="secondary-paragraph">
            <span class="color-error">{{err_msg}}</span>
          </span>
        </label>
      </div>
      <div class="modal-body post-association-card m-3 p-0 post-association-list-height">
        <div class="row m-0">
          <div class="col-12 p-3">
            <div class="ps position-relative" [perfectScrollbar]="config">
              <!--  new design -->
              <div *ngIf="loading_data_in_process==true" class='text-center w-100'>
                <img src="assets/themes/images/img-video-loader.gif" width="40" id="loadmore_post">
              </div>
              <div *ngIf="dss.user_association_list.length > numbers.ZERO">
                <!-- list -->
                <h4 class="heading-4 mb-3">
                  {{mls.languageText.create_post_association.key3}}
                </h4>
                <label class="post-modal-association-list-card py-2 px-3 w-100 d-flex align-items-center justify-content-between"
                  *ngFor="let assList of dss.user_association_list">
                  <div class="float-left d-flex align-items-center">
                    <span class="float-left rounded mr-2">
                      <img alt="pic" class="card-56 rounded-circle" [src]="assList?.profile_pic_path"
                        onerror="this.src='assets/images/grandround/image_placeholder.svg'">
                    </span>
                    <span class="float-left">
                      <span class="paragraph-bold">
                        {{assList?.association_name}}
                      </span>
                    </span>
                  </div>
                  <div class="float-right mb-3">
                    <!-- checkbox -->
                    <div class="checkbox">
                      <input type="checkbox"
                        [checked]="isSelectedAss(assList?.association_id)" (click)="addAssociation($event, assList)"
                        value="{{assList?.association_id}}">
                      <span></span>
                    </div>
                  </div>
                </label>
                <!--end list-->
                <p *ngIf="view_more_association_flag" class="secondary-paragraph-bold my-3 text-center"
                  (click)="showMoreAssociation()">
                  <span class="color-success cursor-pointer">{{mls.languageText.create_post_association.key4}} <span
                      *ngIf="showMoreAssociationCount > 0">{{showMoreAssociationCount}} </span>
                    {{mls.languageText.create_post_association.key5}}
                    <img src="assets/images/webcalendar/down-green-arrow.svg" alt="down arrow" />
                  </span>
                </p>
              </div>
              <div *ngIf="dss.user_association_list.length > numbers.ZERO && showSeperator" class="asstn-list clearfix pt-1 pb-1 border-bottom last-item-border"></div>
              <!-- Community List-->

              <app-post-community (listLength)="showSeperator=$event" 
                (checkSelectedCommunityList)="checkSelectedCommunityList($event)">
              </app-post-community>

              <!-- end Community List-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>